import {
  ICalloutContentStyleProps,
  ICalloutContentStyles
} from '@fluentui/react/lib/Callout';
import { ITheme } from '@fluentui/react/lib/Styling';
import { CoreColors } from '../teams-colors';
import { ShadowLevels } from '../teams-shadow-levels';
import { teamsBorderRadius } from './constants';

export function getCalloutContentStyles(themeName: string, _theme: ITheme) {
  return (props: ICalloutContentStyleProps): Partial<ICalloutContentStyles> => {
    const { theme } = props;
    const { palette } = theme;

    const styles = {
      root: {
        borderRadius: '4px',
        boxShadow: ShadowLevels.shadowLevel3,
        background: palette.white,
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: CoreColors.appBlackAlpha10,
        color: palette.black,
        selectors: {
          '.ms-Spinner': {
            padding: '32px'
          },
          '.ms-CalloutExample-title': {
            color: 'inherit'
          },
          '.ms-CalloutExample-subText': {
            color: 'inherit'
          }
        }
      },
      beakCurtain: {
        borderRadius: teamsBorderRadius
      },
      beak: {
        background: palette.white
      },
      callout: {
        borderRadius: teamsBorderRadius
      },
      calloutMain: {
        borderRadius: teamsBorderRadius,
        background: palette.white
      }
    };

    // Dark theme overrides
    if (themeName === 'dark') {
      styles.root.boxShadow = ShadowLevels.shadowLevel3Dark;
      styles.root.borderColor = palette.white;
      styles.root.background = palette.neutralLight;
      styles.beak.background = palette.neutralLight;
      styles.calloutMain.background = palette.neutralLight;
    }

    // Contrast theme overrides
    if (themeName === 'contrast') {
      styles.root.boxShadow = 'none';
      styles.root.borderColor = palette.black;
      styles.root.background = palette.white;
    }
    return styles;
  };
}
